var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectComp',{attrs:{"required":_vm.required,"disabled":_vm.isDisabled,"options":_vm.options || [],"placeholder":_vm.placeholder},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),(_vm.field?.label)?_c('label',{staticClass:"font-12 select-label"},[_vm._v(_vm._s(_vm.field?.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }